<div class="item-container" *ngIf="link">
  <div class="left-container">
    <div class="drag-indicator">
      <mat-icon> drag_indicator </mat-icon>
    </div>

    <span class="link-icon">
      <app-icon [iconName]="link.iconWeb" [checked]="true"> </app-icon>
    </span>

    <div class="link-name">
      {{ link.name }}
    </div>
  </div>

  <div class="right-container">
    <button class="edit-button" (click)="updateLink(link)">
      <img src="../../../../../assets/icons/lapis-edit.svg" />
    </button>
    <div *ngIf="!link?.integration">
      <button class="delete-button" (click)="deleteLink(link)">
        <img src="../../../../../assets/icons/lixeira2.svg" />
      </button>
    </div>
  </div>
</div>
